import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './pages/Home';
import InvitationPage from './pages/Invitation';

import './App.css';

const App: React.FC = () => {

    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/*" element={<Home/>}/>
                    <Route path="/i/:id" element={<InvitationPage/>}/>
                </Routes>
            </div>
        </Router>
    );
}

export default App;
